import { DDRAGON_BASE_URL } from '../config.js'

const fetchJson = async (url) => {
  const response = await fetch(url)
  if (!response.ok) {
    throw new Error(`Failed to fetch ${url}`)
  }
  return response.json()
}

export const loadTftAssets = async () => {
  const [championsJson, traitsJson] = await Promise.all([
    fetchJson(`${DDRAGON_BASE_URL}/data/en_US/tft-champion.json`),
    fetchJson(`${DDRAGON_BASE_URL}/data/en_US/tft-trait.json`)
  ])

  const champions = championsJson?.data || {}
  const traits = traitsJson?.data || {}

  const championImages = Object.values(champions).reduce((acc, champion) => {
    const id = champion.id
    const image = champion?.image
    if (id && image?.group && image?.full) {
      acc[id] = {
        icon: `${DDRAGON_BASE_URL}/img/${image.group}/${image.full}`
      }
    }
    return acc
  }, {})

  const traitImages = Object.values(traits).reduce((acc, trait) => {
    const id = trait.id
    const image = trait?.image
    if (id && image?.group && image?.full) {
      acc[id] = {
        icon: `${DDRAGON_BASE_URL}/img/${image.group}/${image.full}`
      }
    }
    return acc
  }, {})

  return { championImages, traitImages }
}
